import type { WebsiteMediaItem, WebsiteMediaType } from '../graphql/types';

/** 媒体库里与待上传文件同名、同大小、同类型的文件，视为同一个文件；没有时为 null */
export const findDuplicateMedia = (
    candidates: WebsiteMediaItem[],
    file: Pick<File, 'name' | 'size'>,
    mediaType: WebsiteMediaType,
): WebsiteMediaItem | null =>
    candidates.find((item) => item.mediaType === mediaType && item.fileName === file.name && Number(item.sizeBytes) === file.size) ?? null;
